// extracted by mini-css-extract-plugin
export default {"container":"styles_container__l9GBC","header":"styles_header__UwULd","entries":"styles_entries__VM2kM"};